import none from '../../img/leoLogo.png'
import fizzyblack from '../../img/icetea/fizzyblack.jpg'
import stblack from '../../img/icetea/stblack.jpg'
import lemonblack from '../../img/icetea/lemonblack.jpg'
import simpleblack from '../../img/icetea/simpleblack.jpg'
export const iceTea=[
    {
      "id": "191",
      "title": "Fizzy black",
      "desciption": "چاي سياه سرد دم+آب ليمو+سودا",
      "price": "125",
      "image": fizzyblack
    },
    {
      "id": "192",
      "title": "ST Black",
      "desciption": "چاي سياه سرد دم +توت فرنگي",
      "price": "160",
      "image": stblack
    },
    {
      "id": "193",
      "title": "Lemon Black",
      "desciption": "چاي سياه سرد دم +اب ليمو",
      "price": "140",
      "image": lemonblack
    },
    {
      "id": "194",
      "title": "Simple Black",
      "desciption": "چاي سياه سرد دم",
      "price": "140",
      "image": simpleblack
    },
   
  ]